/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Resource_NameInputs */

const en_admin_resource_form_resource_name = /** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_admin_resource_form_resource_name = /** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const es_admin_resource_form_resource_name = /** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const fr_admin_resource_form_resource_name = /** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

/** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */
const it_admin_resource_form_resource_name = en_admin_resource_form_resource_name;

/** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */
const pt_br2_admin_resource_form_resource_name = en_admin_resource_form_resource_name;

/** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */
const pl_admin_resource_form_resource_name = en_admin_resource_form_resource_name;

/** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */
const hu_admin_resource_form_resource_name = en_admin_resource_form_resource_name;

/** @type {(inputs: Admin_Resource_Form_Resource_NameInputs) => LocalizedString} */
const ro_admin_resource_form_resource_name = en_admin_resource_form_resource_name;

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Admin_Resource_Form_Resource_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_resource_name = /** @type {((inputs?: Admin_Resource_Form_Resource_NameInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Resource_NameInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_resource_name(inputs)
	if (locale === "de") return de_admin_resource_form_resource_name(inputs)
	if (locale === "es") return es_admin_resource_form_resource_name(inputs)
	if (locale === "fr") return fr_admin_resource_form_resource_name(inputs)
	if (locale === "it") return it_admin_resource_form_resource_name(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_resource_name(inputs)
	if (locale === "pl") return pl_admin_resource_form_resource_name(inputs)
	if (locale === "hu") return hu_admin_resource_form_resource_name(inputs)
	return ro_admin_resource_form_resource_name(inputs)
});
export { admin_resource_form_resource_name as "admin.resource_form.resource_name" }